import {
  Cookie as CookieClient,
  createRealTimeCookie,
} from '@cookie-baker/browser';
import { Action, Atom, action } from '@reatom/core';
import { atom } from '@reatom/framework';
import { reatomCookie } from '@reatom/npm-cookie-baker';

type AppBannerModel = {
  appBannerIsHide?: string;
};

let appBannerAtom: {
  cookieAtom: Atom<AppBannerModel>;
  set: Action;
};
if (typeof window !== 'undefined') {
  const cookie = new CookieClient<AppBannerModel>();
  const realTimeCookie = createRealTimeCookie(cookie);

  appBannerAtom = reatomCookie(cookie, realTimeCookie);
} else {
  appBannerAtom = {
    cookieAtom: atom(() => ({}), 'dummyCookieAtom'),
    set: action(),
  };
}
export { appBannerAtom };
